import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { Constants } from 'utilities/constants';

const taskStatuses = {
  [Constants.PostAcqTaskStatus.OPEN]: {
    text: 'Open',
    color: '#565656', // Black
    colorWaterfall: true
  },
  [Constants.PostAcqTaskStatus.CLOSED]: {
    text: 'Closed',
    color: '#67c12e', // Bright green
    colorWaterfall: true
  }
};

export const getChipStatus = (task) => {
  const { taskStatus, underwriteStatus, consumedOn } = task;
  const foundStatus = taskStatuses[taskStatus];
  if (!foundStatus) {
    console.log(`TaskStatusChip.js - taskStatus of ${taskStatus} not recognized`);
    return null;
  }
  let chipColor = foundStatus.color;
  if (foundStatus.colorWaterfall) { // Waterfall the chip color based on other fields
    if (consumedOn != null) { // Task has been consumed
      chipColor = '#408713'; // Dark green
    } else if (taskStatus === Constants.PostAcqTaskStatus.CLOSED) { // Closed task (any UW status - Submitted for most channels, Saved for Acquisitions)
      chipColor = '#67c12e'; // Bright green
    } else if (underwriteStatus === Constants.PostAcqUnderwriteStatus.SAVED) { // Open task with saved valuation but not yet closed
      chipColor = '#faa307'; // Orange
    } else if (task.assignedUser != null && task.postAcquisitionLoadCompletedOn) { // Loaded assigned task
      chipColor = '#e2c600'; // Gold
    } else if (task.assignedUser != null) { // Unloaded assigned task
      chipColor = '#c7be7e' // Gray yellow
    } else if (task.postAcquisitionLoadCompletedOn) { // Loaded unassigned task
      chipColor = '#58b2ff'; // Bright blue
    } // else use taskStatus's default- unloaded unassigned task
  }

  return {
    color: chipColor,
    text: foundStatus.text
  }
}

const TaskStatusChip = ({ classes, style, task, noBackground, highlightStatus }) => {
  if (!task?.taskStatus) return null;
  const myStatus = getChipStatus(task);
  if (!myStatus) return null;
  return <Chip
    classes={{
      root: classes.compTypeChip,
      label: classes.label
    }}
    style={{
      backgroundColor: noBackground ? 'transparent' : myStatus.color,
      color: noBackground ? 'rgba(0, 0, 0, 0.54)' : null,
      border: noBackground ? '1px solid rgba(0, 0, 0, 0.54)' : null,
      width: 90,
      ...style
    }}
    label={highlightStatus ? highlightStatus(myStatus.text) : myStatus.text}
  />
}

const styles = theme => ({
  compTypeChip: {
    height: 18,
    color: '#fff'
  },
  label: {
    overflow: 'initial'
  }
});

export default withStyles(styles)(TaskStatusChip);
